<template>
  <div class="about">
    <div id="content" class="site-content">
      <div
        class="page-header"
        :style="{backgroundImage:`url(${require('../assets/images/subheader-about.jpg')})`}"
        style="background:no-repeat center center;"
      >
        <div class="container">
          <div class="breadc-box no-line">
            <div class="row">
              <div class="col-md-12">
                <h2 class="page-title">汉邦微云</h2>
                <ul id="breadcrumbs" class="breadcrumbs none-style">
                  <li>
                    <router-link :to="{name: 'home'}" class="active_item" exact>首页</router-link>
                  </li>
                  <li class="active">关于我们</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <section>
        <div class="container">
          <div class="row">
            <div class="col-md-6 col-sm-12">
              <h4 class="text-primary">公司简介</h4>
              <h2>汉邦微云</h2>
              <p
                class="about-author"
              >汉邦微云，是一家专业从事酒店信息产业服务与开发的高新企业，有着十几年的行业经验和专业服务，一直在努力研究、探索适合中国酒店业信息技术的应用模式与解决方案，本着简洁、实用、易操作、科学性、严密性的原则，成为酒店行业管理的好帮手。</p>
              <p
                class="about-author"
              >我们始终以“诚信和客户满意”为公司的立业根本，以“创新、求实、进取、共赢”的经营理念，向我们的客户提供最优质、最高效、最专业和最满意的服务。</p>
            </div>
            <div class="col-md-offset-1 col-md-5 col-sm-12 sm-center">
              <div class="about-img-right">
                <img src="../assets/images/about-img.jpg" alt />
              </div>
            </div>
          </div>
        </div>

        <div class="industris-space-60"></div>
        <div class="industris-space"></div>

        <div class="container">
          <div class="row">
            <div class="col-md-4 col-sm-6">
              <div class="icon-box">
                <div class="icon-box-title">
                  <i class="icon ion-md-ribbon"></i>
                  <h4>企业精神</h4>
                </div>
                <p>创新、求实、进取、共赢</p>
              </div>
            </div>
            <div class="col-md-4 col-sm-6">
              <div class="icon-box">
                <div class="icon-box-title">
                  <i class="icon ion-ios-briefcase"></i>
                  <h4>管理宗旨</h4>
                </div>
                <p>以人为本、天天最佳</p>
              </div>
            </div>
            <div class="col-md-4 col-sm-6">
              <div class="icon-box">
                <div class="icon-box-title">
                  <i class="icon ion-ios-contacts"></i>
                  <h4>经营理念</h4>
                </div>
                <p>诚信为本、客户至尊</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="bg-light">
        <div class="container">
          <div class="row">
            <div class="col-md-4 col-xs-6">
              <h3>售前服务</h3>
              <ul class="unstyle padding-right-20">
                <li>
                  <i class="fa fa-check-circle"></i>
                  格局用户的实际情况，帮助用户选择相应的功能模块
                </li>
                <li>
                  <i class="fa fa-check-circle"></i>
                  向用户提供相应的方案资料，为用户进行现场演示
                </li>
                <li>
                  <i class="fa fa-check-circle"></i>
                  向用户提供硬件、网络设备的选型配置咨询
                </li>
                <li>
                  <i class="fa fa-check-circle"></i>
                  ......
                </li>
              </ul>
            </div>
            <div class="col-md-4 col-xs-6 about-border-left">
              <h3>售后服务</h3>
              <ul class="unstyle padding-right-20">
                <li>
                  <i class="fa fa-check-circle"></i>
                  提供酒店管理系统实施的网络技术、系统实施、培训等技术服务
                </li>
                <li>
                  <i class="fa fa-check-circle"></i>
                  提供客服QQ在线服务
                </li>
                <li>
                  <i class="fa fa-check-circle"></i>
                  产品永久免费升级（同版本）
                </li>
                <li>
                  <i class="fa fa-check-circle"></i>
                  ......
                </li>
              </ul>
            </div>
            <div class="col-md-4 col-xs-6 about-border-left">
              <h3>系统安装培训</h3>
              <ul class="unstyle padding-right-20">
                <li>
                  <i class="fa fa-check-circle"></i>
                  向用户提供硬件建议清单，帮助用户选购硬件设备
                </li>
                <li>
                  <i class="fa fa-check-circle"></i>
                  向用户提供综合布线、机房装修资料和建议
                </li>
                <li>
                  <i class="fa fa-check-circle"></i>
                  对店方员工进行培训和考核
                </li>
                <li>
                  <i class="fa fa-check-circle"></i>
                  ......
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <!-- <section>
        <div class="container">
          <div class="row">
            <div class="col-md-12">
              <h4 class="text-primary">公司荣誉</h4>

              <div
                class="partner-slider image-carousel text-center"
                data-show="5"
                data-arrow="false">
                <div>
                  <div class="partner-item text-center clearfix col-md-2 col-xs-6">
                    <div class="inner">
                      <div class="thumb">
                        <img src="../assets/images/partner-logo-1.png" alt />
                      </div>
                    </div>
                  </div>
                </div>

                <div>
                  <div class="partner-item text-center clearfix col-md-2 col-xs-6">
                    <div class="inner">
                      <div class="thumb">
                        <img src="../assets/images/partner-logo-2.png" alt />
                      </div>
                    </div>
                  </div>
                </div>

                <div>
                  <div class="partner-item text-center clearfix col-md-2 col-xs-6">
                    <div class="inner">
                      <div class="thumb">
                        <img src="../assets/images/partner-logo-3.png" alt />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section> -->
    </div>
  </div>
</template>

<script>
import $ from "jquery";

export default {
  name: "about",
  components: {},
  data() {
    return {
      honors: [],
    };
  },
  created() {
    let that = this;
    //数据请求
    this.$axios
      .get("/static/data.json")
      .then(function (response) {
        console.log(response);
        that.honors = response.data.data.honors;
      })
      .catch(function (error) {
        console.log(error);
      });
  },
  computed: {},
  mounted() {},
  methods: {},
};
</script>

<style>
.about-author {
  line-height: 28px;
}
.about-img-right img {
  margin-top: 40px;
}
.text-primary {
  margin-bottom: 40px;
}
</style>



// WEBPACK FOOTER //
// src/pages/about.vue